// extracted by mini-css-extract-plugin
module.exports = {"mobile":"screen and (max-width: 600px)","tablet_only":"(max-width: 1024px) and (min-width: 601px)","wrapper":"wrapper-3bHGd"};